const MOBILE_BREAKPOINT_QUERY = '(min-width: 782px)';

const initArchiveFiltersMobileToggle = ( form ) => {
	if ( ! form || form.dataset.collapseOnMobile !== 'true' ) {
		return;
	}

	if ( form.dataset.mobileToggleInitialized === 'true' ) {
		return;
	}

	const toggleButton = form.previousElementSibling;

	if ( ! toggleButton || ! toggleButton.classList.contains( 'edawp-archive-form__toggle' ) ) {
		return;
	}

	form.dataset.mobileToggleInitialized = 'true';

	const toggleText = toggleButton.querySelector( '.edawp-archive-form__toggle-text' );
	const collapsedText = toggleButton.getAttribute( 'data-toggle-text' ) || '';
	const expandedText = toggleButton.getAttribute( 'data-toggle-text-expanded' ) || collapsedText;
	const openClass = 'is-open';
	const breakpoint = window.matchMedia( MOBILE_BREAKPOINT_QUERY );

	const setExpandedState = ( isExpanded ) => {
		if ( isExpanded ) {
			form.classList.add( openClass );
		} else {
			form.classList.remove( openClass );
		}

		toggleButton.setAttribute( 'aria-expanded', isExpanded ? 'true' : 'false' );

		if ( toggleText ) {
			toggleText.textContent = isExpanded ? expandedText : collapsedText;
		}
	};

	toggleButton.addEventListener( 'click', () => {
		const willExpand = ! form.classList.contains( openClass );
		setExpandedState( willExpand );
	} );

	const syncWithBreakpoint = () => {
		if ( breakpoint.matches ) {
			setExpandedState( true );
		} else {
			setExpandedState( false );
		}
	};

	if ( typeof breakpoint.addEventListener === 'function' ) {
		breakpoint.addEventListener( 'change', syncWithBreakpoint );
	} else if ( typeof breakpoint.addListener === 'function' ) {
		breakpoint.addListener( syncWithBreakpoint );
	}

	syncWithBreakpoint();
};

export default initArchiveFiltersMobileToggle;

export { MOBILE_BREAKPOINT_QUERY };
